import {gsap} from "gsap";
import {Draggable} from "gsap/Draggable";
import {Observer} from "gsap/Observer";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "gsap/SplitText";
import {CustomEase} from "gsap/CustomEase";

gsap.registerPlugin(Draggable, Observer, ScrollTrigger, SplitText, CustomEase);

// Ease d'apparition par défaut (overshoot) — équivalent de
// cubic-bezier(.34, 1.56, .64, 1).
CustomEase.create("ease-overshoot", "M0,0 C0.34,1.56 0.64,1 1,1");

export {gsap};
export {Draggable};
export {Observer};
export {ScrollTrigger};
export {SplitText};
export {CustomEase};
